import React from "react";
import { Modal, Typography } from "antd";
import translator from "@/translator";

const t = translator("note_office.views.referrals.bonus_info_modal.");
const { Title, Text } = Typography;

const BonusInfoModal = ({ open, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    centered
    closable
    focusTriggerAfterClose={false}
    className="referrals__bonus-modal"
    closeIcon={<span className="referrals__bonus-modal-close">&times;</span>}
    width={320}
  >
    <Title level={4} className="referrals__bonus-modal-title">
      {t("title")}
    </Title>
    <Text className="referrals__bonus-modal-desc">{t("description")}</Text>
    <div
      className="referrals__bonus-modal-row"
      dangerouslySetInnerHTML={{ __html: t("free_tier") }}
    />
    <div
      className="referrals__bonus-modal-row"
      dangerouslySetInnerHTML={{ __html: t("basic_tier") }}
    />
    <div
      className="referrals__bonus-modal-row"
      dangerouslySetInnerHTML={{ __html: t("pro_tier") }}
    />
    <div className="referrals__bonus-modal-note">{t("note")}</div>
  </Modal>
);

export default BonusInfoModal;
